//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data: function data() {
		return {
			modalTitle: 'Select Move-In Type',
			selectedMoveInType: true,
			residentSelected: '',
			residents: [],
			isLoading: false,
			convertApp: {},
			convertToResidentRules: [{ model: 'convertApp.move_in_date', rules: 'required | date' }, { model: 'convertApp.email', rules: 'required | email' }, { model: 'convertApp.unitId', rules: 'required' }, { model: 'convertApp.unit_status', rules: 'validate_unit_status' }]
		};
	},
	created: function created() {
		Event.$on('select-move-in-type', this.applicantSelectMoveInType);
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('select-move-in-type');
	},
	mounted: function mounted() {
		var _this = this;

		this.$initValidator();
		axios.get('/prototype/properties/residents').then(function (response) {
			_this.residents = response.data.map(function (u) {
				return {
					label: u.full_name,
					value: u.id
				};
			});
		});

		var unitStatus = ['NTV - Available', 'Vacant - Not Leased'];
		this.validator.extend('validate_unit_status', function (value, arg) {
			return unitStatus.includes(value);
		}, 'This unit status must be either NTV - Available or Vacant - Not Leased');
	},

	methods: {
		applicantSelectMoveInType: function applicantSelectMoveInType(item) {
			var $el = this;
			$el.selectedMoveInType = true;
			$el.modalTitle = 'Select Move-In Type';
			$el.$children[0].$data.showSmallModal = true;
			this.convertApp = item;
		},
		moveInCoResident: function moveInCoResident() {
			this.selectedMoveInType = false;
			this.modalTitle = 'Move-In as Co-Resident';
		},
		moveIn: function moveIn() {
			var _this2 = this;

			this.isLoading = true;
			this.convertApp.resident_id = this.residentSelected.value;
			axios.post('/prototype/applicants/coResidentMoveIn', this.convertApp).then(function (response) {
				if (response.data) {
					_this2.isLoading = false;
					Event.$emit('updated-applicants-list');
					Event.$emit('updated-pending-applicants-list');
					_this2.$snotify.success("Move In successfully.");
					Event.$emit('close-small-modal');
					Event.$emit('close-full-modal');
				}
			});
		},
		moveInAsPrimary: function moveInAsPrimary() {
			this.validator.setRules(this.convertToResidentRules).setCustomMessages({
				'convertApp.move_in_date.required': 'Please supply a Move In date via the Edit screen.',
				'convertApp.unitId.required': 'The Applicant must first select a Unit before converting to Resident.'
			}).validate();
			if (this.validator.fails()) {
				var errors = [];
				errors = this.validator.errorsBag;
				var msg = '';
				errors.forEach(function (error) {
					msg += error.message + '(' + error.model + ')' + '.';
				});
				this.$snotify.error(msg);
			} else {
				Event.$emit('convert-applicant', this.convertApp);
			}
		},

		closeModal: function closeModal() {
			Event.$emit('close-small-modal');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/MoveInType.vue
// module id = tPH7
// module chunks = 0 1